import React, {KeyboardEvent, useState} from 'react';
import SearchIcon from "../../../../ui/svg/common/search";


const VideoSearch = () => {

    const [inputValue, setInputValue] = useState("");

    /**
     * handle key up event - query search on Enter
     */
    const handleKeyUp = async (evt: KeyboardEvent) => {

        if(evt.key === 'Enter') {
            await Search();
        }
    };

    /**
     * handle search action on page number 1
     */
    const Search = async () => {
        window.location.href =  "/videos/search?searchtext=" + inputValue
    };

    return (
        <div className="w-full lg:waves-box-lg lg:mx-auto overflow-hidden">

            <div className="w-full flex items-center justify-center">
                <div className="waves-box-sm border border-gray-200-ho bg-gray-100 outline-none rounded-full flex items-center justify-center">
                    <input
                        type="text"
                        className="w-full bg-gray-100 rounded-full flex-1 p-1 pl-4 md:p-2 md:pl-6 outline-none xl:pl-8"
                        value={ inputValue}
                        placeholder="Search Waves Videos"
                        onKeyUp={ async evt => {
                            await handleKeyUp(evt);
                        }}
                        aria-label="Search Video"
                        onChange={evt => {
                            setInputValue(evt.target.value);
                        }}
                    />
                    <div className="p-3 md:p-5 pr-4 xl:pr-8 cursor-pointer" onClick={Search}>
                        <SearchIcon width="15px" color="#252525" title="Filter" />
                    </div>
                </div>
            </div>
        </div>



    )
};

export default VideoSearch;